import React, { useEffect } from "react";
import UserAdminNavigation from "../general/UserAdminNavigation";
import GeneralAuthentication from "../general/GeneralAuthentication";
import * as theme from "../theme";
import PerfectScrollbar from "react-perfect-scrollbar";
import WelcomeBackRightPane from "../general/WelcomeBackRightPane";
import UserManagement from "../useradmin/UserManagement";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { getBrokerInformation, verifyToken } from "../store/broker";
import Payment from "./payment/Payment";
import TransactionList from "./transactions/TransactionList";
import { getBrokerageInformation, getDetails } from "../store/brokerage";
import translations from "../utils/translations";
function ActiveTab(props) {
  //let view = props.match.params.view;
  const { view } = useParams();
  return <UserManagement view={view} />;
}

const UserAdmin = (props) => {
  const dispatch = useDispatch();
  const broker = useSelector(getBrokerInformation);
  const curTab = ActiveTab(props);
  const { view } = useParams();
  useEffect(() => {
    dispatch(verifyToken());
  }, [dispatch]);
  useEffect(() => {
    dispatch(getDetails());
  }, []);

  return (
    <div>
      {true ? (
        <div
          style={{
            heigth: "100%",
            width: "100%",
            overflow: "hidden",
            backgroundColor: theme.COLORS.tertiary_ligthindigo,
          }}
        >
          <GeneralAuthentication>
            <UserAdminPanel
              style={{ overflow: "hidden" }}
              leftPane={curTab ? curTab : <WelcomeBackRightPane />}
              rightPane={<UserAdminNavigation active={view} />}
              leftPaneWidth={"85%"}
              rightPaneWidth={"15%"}
            />
          </GeneralAuthentication>
        </div>
      ) : (
        <GeneralAuthentication>
          <h1>Error: Access Deniedd</h1>
        </GeneralAuthentication>
      )}
    </div>
  );
};

const UserAdminPanel = (props) => {
  let leftPanel = props.leftPane ? props.leftPane : <div></div>;
  let rightPane = props.rightPane ? props.rightPane : <div></div>;

  let leftPaneWidth = props.leftPaneWidth
    ? props.leftPaneWidth
    : theme.SCALES.quotesLeftPaneWidth;
  let rightPaneWidth = props.rightPaneWidth
    ? props.rightPaneWidth
    : theme.SCALES.quotesRightPaneWidth;

  return (
    <div style={{ display: "flex", height: "100%", width: "100%" }}>
      <div
        style={{
          width: leftPaneWidth,
          height: "100%",
          backgroundColor: theme.COLORS.tertiary_lightbackground,
          boxShadow: "20px 20px 30px 0px #AFB6CC",
          zIndex: 2,
        }}
      >
        <UserAdminLeftPane leftPane={leftPanel} />
      </div>
      <div
        style={{
          width: rightPaneWidth,
          height: "100%",
          zIndex: 1,
          backgroundColor: theme.COLORS.tertiary_ligthindigo,
        }}
      >
        {rightPane}
      </div>
    </div>
  );
};

const UserAdminLeftPane = (props) => {
  let leftPane = props.leftPane ? props.leftPane : <div></div>;
  const broker = useSelector(getBrokerInformation);
  const languagepreference = broker.information.languagepreference;

  const commonStyleForTableBox = {
    border: "5px solid white",
    borderRadius: 10,
    backgroundColor: theme.COLORS.help_tip,
    boxShadow: "0px 0 30px 0px #AFB6CC",
    paddingLeft: 20,
    paddingRight: 20,
  };

  return (
    <div style={{ width: "100%", height: "94vh" }}>
      <PerfectScrollbar>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            paddingLeft: "15%",
            paddingRight: "15%",
          }}
        >
          {}
          <div
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: "1.5vw",
              color: theme.COLORS.primary_navyblue,
              display: "flex",
              paddingTop: "2%",
            }}
          >
            {translations[languagepreference].brokerageAdmin.topAdminHeader}
          </div>
          <br />
        </div>
        <div
          style={{
            marginLeft: "10%",
            marginRight: "10%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            ...commonStyleForTableBox,
          }}
        >
          {leftPane}
        </div>
      </PerfectScrollbar>
    </div>
  );
};

export default UserAdmin;
